import {
  FlowNodeInputTypeEnum,
  FlowNodeTypeEnum,
} from "@packages/flow-core/module/node/constants";
import {
  EditNodeFieldType,
  FlowNodeInputItemType,
} from "@packages/flow-core/module/node/types";
import { Row, Tooltip, message } from "antd";
import { useMemo, useState } from "react";
import styles from "./index.less";
import TargetHandle from "../../../TargetHandle";
import { Immutable } from "immer";
import { useFlow } from "../../../FlowEdit/useFlow";
import FieldEditModal from "../../FieldEditModal";
import { ReactComponent as TipsIcon } from "../../../../../assets/tips.svg";
import { ReactComponent as DeleteIcon } from "../../../../../assets/delete.svg";
import { ReactComponent as SettingIcon } from "../../../../../assets/setting.svg";

export type LabelProps = FlowNodeInputItemType & {
  moduleId: string;
  inputKey: string;
};

export default function Label({ inputKey, ...item }: Immutable<LabelProps>) {
  const {
    required,
    description,
    label,
    type,
    valueType,
    showTargetInApp,
    showTargetInPlugin,
    edit,
    moduleId,
  } = item;
  const { updateModuleInput, deleteModuleInput, getAllNodes } = useFlow();
  const [editFieldValue, setEditFieldValue] = useState<EditNodeFieldType>({});
  const [open, setOpen] = useState(false);

  const isGlobalVariable = useMemo(() => {
    return (
      getAllNodes().find((item) => item.data.moduleId === moduleId)?.data
        .flowType === FlowNodeTypeEnum.globalVariable
    );
  }, [getAllNodes, moduleId]);

  const showHandle = useMemo(() => {
    if (type === FlowNodeInputTypeEnum.target) return true;
    if (showTargetInApp) return true;
    if (showTargetInPlugin) return true;
    return false;
  }, [showTargetInApp, type]);

  return (
    <Row align="middle">
      <div className={styles.container}>
        {label && <span className={styles.label}>{label}</span>}
        {required && <span className={styles.required}>*</span>}
        {description && (
          <Tooltip
            title={
              <span dangerouslySetInnerHTML={{ __html: description }}></span>
            }
          >
            <TipsIcon className={styles.icon} />
          </Tooltip>
        )}
        {showHandle && (
          <TargetHandle
            handleKey={inputKey}
            valueType={valueType}
            moduleId={moduleId}
          />
        )}
        {edit && (
          <>
            <SettingIcon
              className={styles.icon}
              onClick={() => {
                setEditFieldValue({
                  inputType: type,
                  valueType,
                  key: inputKey,
                  required,
                  label,
                  description,
                });
                setOpen(true);
              }}
            />
            <DeleteIcon
              className={`${styles.icon} ${styles.danger}`}
              onClick={() => {
                deleteModuleInput(item.moduleId, inputKey);
              }}
            />
            <FieldEditModal
              visible={open}
              data={editFieldValue}
              field={item.editField!}
              onClose={() => {
                setOpen(false);
              }}
              onConfirm={(data) => {
                if (data.key !== editFieldValue?.key) {
                  const module = getAllNodes().find(
                    (item) => item.data.moduleId === moduleId
                  )?.data;
                  const existed = module?.inputs.find(
                    (item) => item.key === data.key
                  );
                  if (existed) {
                    message.warning("字段Key不能重复");
                    return;
                  }
                }
                updateModuleInput(item.moduleId, inputKey, {
                  ...(editFieldValue as any),
                  type: data.inputType || item.type || "target",
                  valueType: data.valueType || editFieldValue?.valueType,
                  key: data.key!,
                  required: data.required,
                  label: data.label || data.key!,
                  description: data.description,
                  showTargetInApp: isGlobalVariable
                    ? true
                    : item.showTargetInApp,
                  edit: true,
                  editField: item.editField,
                });
                setOpen(false);
              }}
            />
          </>
        )}
      </div>
    </Row>
  );
}
